import React from 'react'
import { EventGQL } from '../../../../../Api/events/events.types'
import { Team } from '../../../../../Api/teams/teams.types'
import { Season, SeasonType } from '../../../../../Context/SeasonContext/SeasonContext'
import { createTeamDynamicLink } from '../../../../../Utils/dynamicLinks/dynamicLinkHelpers'
import { getTeamRecord } from '../../../../../Utils/TeamHelpers/teamHelpers'
import { TeamInfoCon } from '../../styles'
import { SEASON_SEGMENT_NAMES } from '../../../../../Constants/season'
import { getTeamImage } from '../../../../TeamComponents/TeamImage/TeamIC'
import { Img } from '../../../../Images/Img'

type ActionProps = {
  event: EventGQL
  team: Team
  uiTheme?: 'light' | 'dark'
}

export const BoxScoreTeam: React.FC<React.PropsWithChildren<ActionProps>> = ({
  event,
  team,
  uiTheme = 'light',
}) => {
  const segment: Season = {
    year: event.year,
    seasonType: event.seasonSegment as SeasonType,
  }

  const createTeamLink = () => {
    if (event.seasonSegment === SEASON_SEGMENT_NAMES.allstar) {
      return `/all-star`
    }
    return createTeamDynamicLink(team)
  }

  const teamImg = getTeamImage(team.fullName, event?.year, event?.seasonSegment)

  return (
    <TeamInfoCon href={createTeamLink()} uiTheme={uiTheme}>
      <div className="logoCon">
        <Img src={teamImg} alt={`${team?.fullName} logo`} />
      </div>
      <div className="nameAndRecordCon">
        <div className="teamNameCon">
          <p className="teamName">{team?.locationCode || team.officialId}</p>
        </div>
        <p className="record">
          {event?.eventStatus < 2 &&
            event.seasonSegment !== SEASON_SEGMENT_NAMES.allstar &&
            team &&
            getTeamRecord(team, segment)}
        </p>
      </div>
    </TeamInfoCon>
  )
}
